import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  OnInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[digitalPlatformLatLongFormat]',
  standalone: true,
})
export class LatLongFormatDirective implements OnInit {
  private ngControl = inject(NgControl);

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.formatValue(this.ngControl.control?.value);
  }

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;
    this.formatValue(value);
  }

  private formatValue(value: string): void {
    if (!value) return;

    // Step 1: Remove all characters except digits, period, and an optional leading plus or minus sign
    let cleanValue = value.replace(/[^\d.\-+]/g, '');

    // Step 2: Ensure only one leading minus sign is present, if any
    const negativeSignParts = cleanValue
      .split('-')
      .filter((part) => part !== '');
    if (negativeSignParts.length > 1) {
      // Reattach the first part with a minus sign, if the original string started with it
      cleanValue =
        (value.startsWith('-') ? '-' : '') + negativeSignParts.join('');
    } else {
      cleanValue = cleanValue.startsWith('-')
        ? '-' + negativeSignParts.join('')
        : negativeSignParts.join('');
    }

    // Step 3: Limit to one occurrence of the '.' character
    const parts = cleanValue.split('.');
    if (parts.length > 2) {
      // If there are more than one '.', keep only the first two parts
      cleanValue = parts.slice(0, 2).join('.');
    }

    // Step 4: Limit the number of digits after the '.' character to 15
    if (parts.length === 2) {
      const decimalPart = parts[1].slice(0, 15);
      cleanValue = `${parts[0]}.${decimalPart}`;
    }

    this.ngControl.control?.setValue(cleanValue, { emitEvent: false });
    this.el.nativeElement.value = cleanValue;
  }
}
